// Chart 4 & 5: 적립 구간 자산 성장 전망 — port of make_line_projection()
import usePlotly from './usePlotly';
import { toManwon } from '../../lib/format';

export default function LineProjectionChart({ years, base, cons, opt, title }) {
  const ref = usePlotly(() => ({
    data: [
      {
        type: 'scatter',
        mode: 'lines',
        name: '기준',
        x: years,
        y: toManwon(base),
        line: { color: '#7a451f', width: 2 },
      },
      {
        type: 'scatter',
        mode: 'lines',
        name: '보수 (-2%p)',
        x: years,
        y: toManwon(cons),
        line: { color: '#f28b82', width: 2, dash: 'dot' },
      },
      {
        type: 'scatter',
        mode: 'lines',
        name: '낙관 (+2%p)',
        x: years,
        y: toManwon(opt),
        line: { color: '#9a6338', width: 2, dash: 'dash' },
      },
    ],
    layout: {
      title: { text: title, font: { size: 13 } },
      height: 400,
      xaxis: { title: '경과 (년)', gridcolor: '#ead9c7', zerolinecolor: '#ead9c7' },
      yaxis: { title: '자산 (만원)', ticksuffix: '만', tickformat: '.0f', gridcolor: '#ead9c7' },
    },
  }), [years, base, cons, opt, title]);

  return <div ref={ref} style={{ width: '100%' }} />;
}
